import React from 'react';
import { TabsOption } from 'global';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { FinancePerformancePage } from 'modules/finance/performance';
import { FinanceList } from '../components';

type FinancePageTab = 'finance-log' | 'performance';

const tabs: TabsOption<FinancePageTab>[] = [
  {
    value: 'performance',
    label: 'Performance',
    component: <FinancePerformancePage />,
  },
  {
    value: 'finance-log',
    label: 'Finance Log',
    component: (
      <CardContainer>
        <FinanceList />
      </CardContainer>
    ),
  },
];

export const FinanceListPage = () => {
  return (
    <PageContainer title="Finance">
      <TabsContainer<FinancePageTab> tabs={tabs} />
    </PageContainer>
  );
};
